<body>
    <div class="container">
        <div *ngIf="dataLoaded" class="table-container scrollable-container">
            <div class="divInfo" id="titulo">
                <div id="flitrarData" class="divInfoConteudo">
                    <input id="dataInput" type="date" name="dataFiltro" [(ngModel)]="dataFiltro">
                    <button class="select-input" (click)="dataFilter()">Filtrar</button>
                    <!-- <input id="dataMostrar" name="dataMostra" [(ngModel)]="dataMostra" type="text"> -->
                    <span id="dataMostrar">{{ dataMostra | date:'dd/MM/yyyy' }}</span>
                </div>
                <div class="divInfoConteudo">
                    <h1 class="tituloColunas">BRIEFING</h1>
                </div>
                <!-- <div id="flitrarData" class="divInfoConteudo">
                    <button class="select-input" (click)="dialogOpen = true">INSERIR DADOS BRIEFING</button>
                </div> -->
            </div>
            <table class="geralTable">
                <thead class="sticky-header">
                    <tr>
                        <th class="titulo-coluna">
                            <span class="semFundo">INTERPLANTS</span>
                        </th>
                        <th class="titulo-coluna">
                            <span class="semFundo">IMPORTAÇÃO</span>
                        </th>
                        <th class="titulo-coluna">
                            <span class="semFundo">EXPORTAÇÃO</span>
                        </th>
                        <th class="titulo-coluna">
                            <span class="semFundo">REUTILIZAÇÃO</span>
                        </th>
                        <th class="titulo-coluna">
                            <span class="semFundo">E-CARRIER</span>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="corpoTimeTable">
                        <td class="centralizado">
                            <div class="divInfo">
                                <div class="divInfoConteudo">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">Realizadas:
                                        </abbr>
                                    </span>
                                </div>
                                <div class="divInfoConteudo">
                                    <input type="number" name="intRealizadas" [(ngModel)]="interplantas.intRealizadas">
                                </div>
                                <div class="divInfoConteudo">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">MU:
                                        </abbr>
                                    </span>
                                </div>
                                <div class="divInfoConteudo">
                                    <input type="number" name="intMu" [(ngModel)]="interplantas.intMu">
                                </div>
                            </div>
                            <div class="divInfo">
                                <div class="divInfoConteudo">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">Cancelado(s):
                                        </abbr>
                                    </span>
                                </div>
                                <div class="divInfoConteudo">
                                    <input type="number" name="intCanceladas" [(ngModel)]="interplantas.intCanceladas">
                                </div>
                            </div>
                            <div class="divInfo">
                                <div class="divInfoConteudo">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">Critico:
                                        </abbr>
                                    </span>
                                </div>
                                <div class="divInfoConteudo">
                                    <input type="number" name="intCritico" [(ngModel)]="interplantas.intCritico">
                                </div>
                            </div>
                            <div class="divInfo">
                                <div class="divInfoConteudo">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">Observações:
                                        </abbr>
                                    </span>
                                </div>
                                <div class="divInfoConteudo">
                                    <input type="text" name="intObs" [(ngModel)]="interplantas.intObs">
                                </div>
                            </div>
                            <!-- <div class="modal-div botoes">
                                <button class="modal-button" type="button"
                                    (click)="salvar()">Save</button>
                            </div> -->
                        </td>
                        <td class="centralizado">
                            <div class="divInfo">
                                <div class="divInfoConteudo">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">Viagens:
                                        </abbr>
                                    </span>
                                </div>
                                <div class="divInfoConteudo">
                                    <input type="number" name="impViagens" [(ngModel)]="importacao.impViagens">
                                </div>
                                <div class="divInfoConteudo">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">MU:
                                        </abbr>
                                    </span>
                                </div>
                                <div class="divInfoConteudo">
                                    <input type="number" name="impMu" [(ngModel)]="importacao.impMu">
                                </div>
                            </div>
                            <div class="divInfo">
                                <div class="divInfoConteudo">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">LCB:
                                        </abbr>
                                    </span>
                                </div>
                                <div class="divInfoConteudo">
                                    <input type="number" name="impLcb" [(ngModel)]="importacao.impLcb">
                                </div>
                                <div class="divInfoConteudo">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">SLA:
                                        </abbr>
                                    </span>
                                </div>
                                <div class="divInfoConteudo">
                                    <input type="number" name="impSla" [(ngModel)]="importacao.impSla">
                                </div>
                            </div>
                            <div class="divInfo">
                                <div class="divInfoConteudo">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">LC:
                                        </abbr>
                                    </span>
                                </div>
                                <div class="divInfoConteudo">
                                    <input type="number" name="impLc" [(ngModel)]="importacao.impLc">
                                </div>
                                <div class="divInfoConteudo">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">ARG:
                                        </abbr>
                                    </span>
                                </div>
                                <div class="divInfoConteudo">
                                    <input type="number" name="impArg" [(ngModel)]="importacao.impArg">
                                </div>
                            </div>
                            <div class="divInfo">
                                <div class="divInfoConteudo">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">Observações:
                                        </abbr>
                                    </span>
                                </div>
                                <div class="divInfoConteudo">
                                    <input type="text" name="impObs" [(ngModel)]="importacao.impObs">
                                </div>
                            </div>
                            <!-- <div class="modal-div botoes">
                                <button class="modal-button" type="button"
                                    (click)="salvar()">Save</button>
                            </div> -->
                        </td>
                        <td class="centralizado">
                            <div class="divInfo">
                                <div class="divInfoConteudo">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">Viagens:
                                        </abbr>
                                    </span>
                                </div>
                                <div class="divInfoConteudo">
                                    <input type="number" name="expViagens" [(ngModel)]="exportacao.expViagens">
                                </div>
                                <div class="divInfoConteudo">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">MU:
                                        </abbr>
                                    </span>
                                </div>
                                <div class="divInfoConteudo">
                                    <input type="number" name="expMu" [(ngModel)]="exportacao.expMu">
                                </div>
                            </div>
                            <div class="divInfo">
                                <div class="divInfoConteudo">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">LCB:
                                        </abbr>
                                    </span>
                                </div>
                                <div class="divInfoConteudo">
                                    <input type="number" name="expLcb" [(ngModel)]="exportacao.expLcb">
                                </div>
                                <div class="divInfoConteudo">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">KD:
                                        </abbr>
                                    </span>
                                </div>
                                <div class="divInfoConteudo">
                                    <input type="number" name="expKd" [(ngModel)]="exportacao.expKd">
                                </div>
                            </div>
                            <div class="divInfo">
                                <div class="divInfoConteudo">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">Navistar:
                                        </abbr>
                                    </span>
                                </div>
                                <div class="divInfoConteudo">
                                    <input type="number" name="expNavistar" [(ngModel)]="exportacao.expNavistar">
                                </div>
                                <div class="divInfoConteudo">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">China:
                                        </abbr>
                                    </span>
                                </div>
                                <div class="divInfoConteudo">
                                    <input type="number" name="expChina" [(ngModel)]="exportacao.expChina">
                                </div>
                            </div>
                            <div class="divInfo">
                                <div class="divInfoConteudo">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">Observações:
                                        </abbr>
                                    </span>
                                </div>
                                <div class="divInfoConteudo">
                                    <input type="text" name="expObs" [(ngModel)]="exportacao.expObs">
                                </div>
                            </div>
                            <!-- <div class="modal-div botoes">
                                <button class="modal-button" type="button"
                                    (click)="salvar()">Save</button>
                            </div> -->
                        </td>
                        <td class="centralizado">
                            <div class="divInfo">
                                <div class="divInfoConteudo">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">Realizadas:
                                        </abbr>
                                    </span>
                                </div>
                                <div class="divInfoConteudo">
                                    <input type="number" name="reutRealizadas"
                                        [(ngModel)]="reutilizacao.reutRealizadas">
                                </div>
                            </div>
                            <div class="divInfo">
                                <div class="divInfoConteudo">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">Cancelado(s):
                                        </abbr>
                                    </span>
                                </div>
                                <div class="divInfoConteudo">
                                    <input type="number" name="reutCanceladas"
                                        [(ngModel)]="reutilizacao.reutCanceladas">
                                </div>
                            </div>
                            <div class="divInfo">
                                <div class="divInfoConteudo">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">Crítico:
                                        </abbr>
                                    </span>
                                </div>
                                <div class="divInfoConteudo">
                                    <input type="text" name="reutCritico" [(ngModel)]="reutilizacao.reutCritico">
                                </div>
                            </div>
                            <div class="divInfo">
                                <div class="divInfoConteudo">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">Observações:
                                        </abbr>
                                    </span>
                                </div>
                                <div class="divInfoConteudo">
                                    <input type="text" name="reutObs" [(ngModel)]="reutilizacao.reutObs">
                                </div>
                            </div>
                            <!-- <div class="modal-div botoes">
                                <button class="modal-button" type="button"
                                    (click)="salvar()">Save</button>
                            </div> -->
                        </td>
                        <td class="centralizado">
                            <div class="divInfo">
                                <div class="divInfoConteudo">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">Data:
                                        </abbr>
                                    </span>
                                </div>
                                <div class="divInfoConteudo">
                                    <input type="text" name="eCarData" [(ngModel)]="eCarrier.eCarData">
                                </div>
                            </div>
                            <div class="divInfo">
                                <div class="divInfoConteudo">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">E-Carrier:
                                        </abbr>
                                    </span>
                                </div>
                                <div class="divInfoConteudo">
                                    <input type="text" name="eCarEcarrier" [(ngModel)]="eCarrier.eCarEcarrier">
                                </div>
                            </div>
                            <div class="divInfo">
                                <div class="divInfoConteudo">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">Responsável:
                                        </abbr>
                                    </span>
                                </div>
                                <div class="divInfoConteudo">
                                    <input type="text" name="eCarResponsavel" [(ngModel)]="eCarrier.eCarResponsavel">
                                </div>
                            </div>
                            <div class="divInfo">
                                <div class="divInfoConteudo">
                                    <span>
                                        <abbr
                                            style="color: #000000; font-weight: bold;">Transportadora:
                                        </abbr>
                                    </span>
                                </div>
                                <div class="divInfoConteudo">
                                    <input type="text" name="eCarTransportadora"
                                        [(ngModel)]="eCarrier.eCarTransportadora">
                                </div>
                            </div>
                            <div class="divInfo">
                                <div class="divInfoConteudo">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">Observações:
                                        </abbr>
                                    </span>
                                </div>
                                <div class="divInfoConteudo">
                                    <input type="text" name="eCarObs" [(ngModel)]="eCarrier.eCarObs">
                                </div>
                            </div>
                            <!-- <div class="modal-div botoes">
                                <button class="modal-button" type="button"
                                    (click)="salvar()">Save</button>
                            </div> -->
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div *ngIf="dataLoaded" class="table-container scrollable-container">
            <table class="geralTable">
                <thead class="sticky-header">
                    <tr>
                        <th class="titulo-coluna">
                            <span class="semFundo">FRETE EXTRA</span>
                        </th>
                        <th class="titulo-coluna">
                            <span class="semFundo">MR JSL</span>
                        </th>
                        <th class="titulo-coluna">
                            <span class="semFundo">MR TCM</span>
                        </th>
                        <th class="titulo-coluna">
                            <span class="semFundo">DESVIOS</span>
                        </th>
                        <th class="titulo-coluna">
                            <span class="semFundo">SOTIF</span>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="corpoTimeTable">
                        <td class="centralizado">
                            <div class="divInfo">
                                <div class="divInfoConteudo">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">Planejadas:
                                        </abbr>
                                    </span>
                                </div>
                                <div class="divInfoConteudo">
                                    <input type="number" name="fexPlanejadas" [(ngModel)]="freteExtra.fexPlanejadas">
                                </div>
                                </div>
                            <div class="divInfo">
                                <div class="divInfoConteudo">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">Realizadas:
                                        </abbr>
                                    </span>
                                </div>
                                <div class="divInfoConteudo">
                                    <input type="number" name="fexRealizadas" [(ngModel)]="freteExtra.fexRealizadas">
                                </div>
                            </div>
                            <div class="divInfo">
                                <div class="divInfoConteudo">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">RMC-3061:
                                        </abbr>
                                    </span>
                                </div>
                                <div class="divInfoConteudo">
                                    <input type="number" name="fexRmc" [(ngModel)]="freteExtra.fexRmc">
                                </div>
                            </div>
                            <div class="divInfo">
                                <div class="divInfoConteudo">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">LOMLT-3121:
                                        </abbr>
                                    </span>
                                </div>
                                <div class="divInfoConteudo">
                                    <input type="number" name="fexLomlt" [(ngModel)]="freteExtra.fexLomlt">
                                </div>
                            </div>
                            <div class="divInfo">
                                <div class="divInfoConteudo">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">Observações:
                                        </abbr>
                                    </span>
                                </div>
                                <div class="divInfoConteudo">
                                    <input type="text" name="fexObs" [(ngModel)]="freteExtra.fexObs">
                                </div>
                            </div>
                            <!-- <div class="modal-div botoes">
                                <button class="modal-button" type="button"
                                    (click)="salvar()">Save</button>
                            </div> -->
                        </td>
                        <td class="centralizado">
                            <div class="divInfo">
                                <div class="divInfoConteudo">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">Realizadas:
                                        </abbr>
                                    </span>
                                </div>
                                <div class="divInfoConteudo">
                                    <input type="number" name="jslRealizadas" [(ngModel)]="mrjsl.jslRealizadas">
                                </div>
                            </div>
                            <div class="divInfo">
                                <div class="divInfoConteudo">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">MU:
                                        </abbr>
                                    </span>
                                </div>
                                <div class="divInfoConteudo">
                                    <input type="number" name="jslmu" [(ngModel)]="mrjsl.jslmu">
                                </div>
                            </div>
                            <div class="divInfo">
                                <div class="divInfoConteudo">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">Sul:
                                        </abbr>
                                    </span>
                                </div>
                                <div class="divInfoConteudo">
                                    <input type="number" name="jslSul" [(ngModel)]="mrjsl.jslSul">
                                </div>
                            </div>
                            <div class="divInfo">
                                <div class="divInfoConteudo">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">SP:
                                        </abbr>
                                    </span>
                                </div>
                                <div class="divInfoConteudo">
                                    <input type="number" name="jslSp" [(ngModel)]="mrjsl.jslSp">
                                </div>
                            </div>
                            <div class="divInfo">
                                <div class="divInfoConteudo">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">Observações:
                                        </abbr>
                                    </span>
                                </div>
                                <div class="divInfoConteudo">
                                    <input type="text" name="jslObs" [(ngModel)]="mrjsl.jslObs">
                                </div>
                            </div>
                            <!-- <div class="modal-div botoes">
                                <button class="modal-button" type="button"
                                    (click)="salvar()">Save</button>
                            </div> -->
                        </td>
                        <td class="centralizado">
                            <div class="divInfo">
                                <div class="divInfoConteudo">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">Realizadas:
                                        </abbr>
                                    </span>
                                </div>
                                <div class="divInfoConteudo">
                                    <input type="number" name="tcmRealizadas" [(ngModel)]="mrtcm.tcmRealizadas">
                                </div>
                                <div class="divInfoConteudo">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">MU:
                                        </abbr>
                                    </span>
                                </div>
                                <div class="divInfoConteudo">
                                    <input type="number" name="tcmMu" [(ngModel)]="mrtcm.tcmMu">
                                </div>
                            </div>
                            <div class="divInfo">
                                <div class="divInfoConteudo">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">Coletas:
                                        </abbr>
                                    </span>
                                </div>
                                <div class="divInfoConteudo">
                                    <input type="number" name="tcmColetas" [(ngModel)]="mrtcm.tcmColetas">
                                </div>
                                <div class="divInfoConteudo">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">Carros:
                                        </abbr>
                                    </span>
                                </div>
                                <div class="divInfoConteudo">
                                    <input type="number" name="tcmCarros" [(ngModel)]="mrtcm.tcmCarros">
                                </div>
                            </div>
                            <div class="divInfo">
                                <div class="divInfoConteudo">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">Entregas:
                                        </abbr>
                                    </span>
                                </div>
                                <div class="divInfoConteudo">
                                    <input type="number" name="tcmEntregas" [(ngModel)]="mrtcm.tcmEntregas">
                                </div>
                            </div>
                            <div class="divInfo">
                                <div class="divInfoConteudo">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">Observações:
                                        </abbr>
                                    </span>
                                </div>
                                <div class="divInfoConteudo">
                                    <input type="text" name="tcmObs" [(ngModel)]="mrtcm.tcmObs">
                                </div>
                            </div>
                            <!-- <div class="modal-div botoes">
                                <button class="modal-button" type="button"
                                    (click)="salvar()">Save</button>
                            </div> -->
                        </td>
                        <td class="centralizado">
                            <div class="divInfo">
                                <div class="divInfoConteudo">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">Scania:
                                        </abbr>
                                    </span>
                                </div>
                                <div class="divInfoConteudo">
                                    <input type="text" name="desvScania" [(ngModel)]="desvios.desvScania">
                                </div>
                            </div>
                            <div class="divInfo">
                                <div class="divInfoConteudo">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">LCB:
                                        </abbr>
                                    </span>
                                </div>
                                <div class="divInfoConteudo">
                                    <input type="text" name="desvLCB" [(ngModel)]="desvios.desvLCB">
                                </div>
                            </div>
                            <div class="divInfo">
                                <div class="divInfoConteudo">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">Fornecedor:
                                        </abbr>
                                    </span>
                                </div>
                                <div class="divInfoConteudo">
                                    <input type="text" name="desvForn" [(ngModel)]="desvios.desvForn">
                                </div>
                            </div>
                            <div class="divInfo">
                                <div class="divInfoConteudo">
                                    <span>
                                        <abbr
                                            style="color: #000000; font-weight: bold;">Transportadora:
                                        </abbr>
                                    </span>
                                </div>
                                <div class="divInfoConteudo">
                                    <input type="text" name="desvTransportadora"
                                        [(ngModel)]="desvios.desvTransportadora">
                                </div>
                            </div>
                            <div class="divInfo">
                                <div class="divInfoConteudo">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">Crítico:
                                        </abbr>
                                    </span>
                                </div>
                                <div class="divInfoConteudo">
                                    <input type="text" name="desvCritico" [(ngModel)]="desvios.desvCritico">
                                </div>
                            </div>
                            <div class="divInfo">
                                <div class="divInfoConteudo">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">Observações:
                                        </abbr>
                                    </span>
                                </div>
                                <div class="divInfoConteudo">
                                    <input type="text" name="desvObs" [(ngModel)]="desvios.desvObs">
                                </div>
                            </div>
                            <!-- <div class="modal-div botoes">
                                <button class="modal-button" type="button"
                                    (click)="salvar()">Save</button>
                            </div> -->
                        </td>
                        <td class="centralizado">
                            <div class="divInfo">
                                <div class="divInfoConteudo">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">Prec:
                                        </abbr>
                                    </span>
                                </div>
                                <div class="divInfoConteudo">
                                    <input type="number" name="sotPrec" [(ngModel)]="sotif.sotPrec">
                                </div>
                            </div>
                            <div class="divInfo">
                                <div class="divInfoConteudo">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">Transporte:
                                        </abbr>
                                    </span>
                                </div>
                                <div class="divInfoConteudo">
                                    <input type="number" name="sotTransporte" [(ngModel)]="sotif.sotTransporte">
                                </div>
                            </div>
                            <!-- <div class="modal-div botoes">
                                <button class="modal-button" type="button"
                                    (click)="salvar()">Save</button>
                            </div> -->
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</body>
<!-- 
<clr-modal [(clrModalOpen)]="dialogOpen" [clrModalSize]="'xl'" class="dialog-container">
    <h3 class="modal-title">VOLUME DE RECEBIMENTO LCB</h3>
    <div class="modal-body">
        <form class="inputs">
            <div *ngIf="dataLoaded" class="table-container scrollable-container">
                <table class="geralTable">
                    <thead class="sticky-header">
                        <tr>
                          <th class="col-op-width titulos-inserir">
                            <span class="semFundo">OPERAÇÃO</span>
                          </th>
                          <th class="titulos-inserir">
                            <span class="semFundo">TRANSPORTADORA</span>
                          </th>
                          <th class="titulos-inserir">
                            <span class="semFundo">VEÍCULOS (QT.)</span>
                          </th>
                          <th class="titulos-inserir">
                            <span class="semFundo">PALLETS (QT.)</span>
                          </th>
                          <th class="titulos-inserir">
                            <span class="semFundo">MÉDIA (PALLET/VEÍCULO)</span>
                          </th>
                        </tr>
                      </thead>
                    <tbody>
                        <tr class="corpoTimeTable">
                            <td class="centralizado">
                                <div class="tituloInputValue">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">Frete Extra:
                                        </abbr>
                                    </span>
                                </div>
                                <hr> 
                                <div class="tituloInputValue">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">Aéreo:
                                        </abbr>
                                    </span>
                                </div>
                                <hr> 
                                <div class="tituloInputValue">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">Frete
                                            Marítimo CRAGEA:
                                        </abbr>
                                    </span>
                                </div>
                                <hr> 
                                <div class="tituloInputValue">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">Frete
                                            Marítimo Santos:
                                        </abbr>
                                    </span>
                                </div>
                                <hr> 
                                <div class="tituloInputValue">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">Frete
                                            Marítimo CRAGEA:
                                        </abbr>
                                    </span>
                                </div>
                                <hr> 
                                <div class="tituloInputValue">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">Frete
                                            Marítimo Santos:
                                        </abbr>
                                    </span>
                                </div>
                                <hr> 
                                <div class="tituloInputValue">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">Frete
                                            Marítimo CRAGEA:
                                        </abbr>
                                    </span>
                                </div>
                                <hr> 
                                <div class="tituloInputValue">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">Frete
                                            Marítimo Santos:
                                        </abbr>
                                    </span>
                                </div>
                                <hr> 
                                <div class="tituloInputValue">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">Milk Run São
                                            Paulo:
                                        </abbr>
                                    </span>
                                </div>
                                <hr> 
                                <div class="tituloInputValue">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">Diretos:
                                        </abbr>
                                    </span>
                                </div>
                                <hr> 
                                <div class="tituloInputValue">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">Milk Run Sul:
                                        </abbr>
                                    </span>
                                </div>
                                <hr> 
                                <div class="tituloInputValue">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">Milk Run
                                            Argentina:
                                        </abbr>
                                    </span>
                                </div>
                            </td>
                            <td class="centralizado">
                                <div class="tituloInputValue">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">EXTRA:
                                        </abbr>
                                    </span>
                                </div>
                                <hr> 
                                <div class="tituloInputValue">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">RODO IMPORT:
                                        </abbr>
                                    </span>
                                </div>
                                <hr> 
                                <div class="tituloInputValue">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">LOTS:
                                        </abbr>
                                    </span>
                                </div>
                                <hr> 
                                <div class="tituloInputValue">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">LOTS:
                                        </abbr>
                                    </span>
                                </div>
                                <hr> 
                                <div class="tituloInputValue">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">SUZAN:
                                        </abbr>
                                    </span>
                                </div>
                                <hr> 
                                <div class="tituloInputValue">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">SUZAN:
                                        </abbr>
                                    </span>
                                </div>
                                <hr> 
                                <div class="tituloInputValue">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">GLOVIS:
                                        </abbr>
                                    </span>
                                </div>
                                <hr> 
                                <div class="tituloInputValue">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">GLOVIS:
                                        </abbr>
                                    </span>
                                </div>
                                <hr>                               
                                <div class="tituloInputValue">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">JSL:
                                        </abbr>
                                    </span>
                                </div>
                                <hr> 
                                <div class="tituloInputValue">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">NORMAL:
                                        </abbr>
                                    </span>
                                </div>
                                <hr> 
                                <div class="tituloInputValue">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">TCM:
                                        </abbr>
                                    </span>
                                </div>
                                <hr> 
                                <div class="tituloInputValue">
                                    <span>
                                        <abbr style="color: #000000; font-weight: bold;">JSL:
                                        </abbr>
                                    </span>
                                </div>
                            </td>                          
                            <td class="centralizado">
                                <div class="inputValue marginCima">
                                    <input type="number" id="quantidades" name="qtVeiculosFE" [(ngModel)]="volRecebimento.qtVeiculosFE"  (focus)="selecionarTexto($event)">
                                </div>
                                <hr> 
                                <div class="inputValue">
                                    <input type="number" id="quantidades" name="qtVeiculosAereo" [(ngModel)]="volRecebimento.qtVeiculosAereo">
                                </div>
                                <hr> 
                                <div class="inputValue">
                                    <input type="number" id="quantidades" name="qtVeiculosCrageaLots" [(ngModel)]="volRecebimento.qtVeiculosCrageaLots">
                                </div>
                                <hr> 
                                <div class="inputValue">
                                    <input type="number" id="quantidades" name="qtVeiculosSantosLots" [(ngModel)]="volRecebimento.qtVeiculosSantosLots">
                                </div>
                                <hr> 
                                <div class="inputValue">
                                    <input type="number" id="quantidades" name="qtVeiculosCrageaSuzan" [(ngModel)]="volRecebimento.qtVeiculosCrageaSuzan">
                                </div>
                                <hr> 
                                <div class="inputValue">
                                    <input type="number" id="quantidades" name="qtVeiculosSantosSuzan" [(ngModel)]="volRecebimento.qtVeiculosSantosSuzan">
                                </div>
                                <hr> 
                                <div class="inputValue">
                                    <input type="number" id="quantidades" name="qtVeiculosCrageaGlovis" [(ngModel)]="volRecebimento.qtVeiculosCrageaGlovis">
                                </div>
                                <hr> 
                                <div class="inputValue">
                                    <input type="number" id="quantidades" name="qtVeiculosSantosGlovis" [(ngModel)]="volRecebimento.qtVeiculosSantosGlovis">
                                </div>
                                <hr> 
                                <div class="inputValue">
                                    <input type="number" id="quantidades" name="qtVeiculosMRjsl" [(ngModel)]="volRecebimento.qtVeiculosMRjsl">
                                </div>
                                <hr> 
                                <div class="inputValue">
                                    <input type="number" id="quantidades" name="qtVeiculosDiretos" [(ngModel)]="volRecebimento.qtVeiculosDiretos">
                                </div>
                                <hr> 
                                <div class="inputValue">
                                    <input type="number" id="quantidades" name="qtVeiculosMRtcm" [(ngModel)]="volRecebimento.qtVeiculosMRtcm">
                                </div>
                                <hr> 
                                <div class="inputValue">
                                    <input type="number" id="quantidades" name="qtVeiculosARGjsl" [(ngModel)]="volRecebimento.qtVeiculosARGjsl">
                                </div>
                            </td>
                            <td class="centralizado">
                                <div class="inputValue marginCima">
                                    <input type="number" id="quantidades" name="qtPalletsFE" [(ngModel)]="volRecebimento.qtPalletsFE"  (focus)="selecionarTexto($event)"  
                                    (ngModelChange)="calcularMedia('qtMediaFE', volRecebimento.qtPalletsFE, volRecebimento.qtVeiculosFE)">
                                </div>
                                <hr> 
                                <div class="inputValue">
                                    <input type="number" id="quantidades" name="qtPalletsAereo" [(ngModel)]="volRecebimento.qtPalletsAereo">
                                </div>
                                <hr> 
                                <div class="inputValue">
                                    <input type="number" id="quantidades" name="qtPalletsCrageaLots" [(ngModel)]="volRecebimento.qtPalletsCrageaLots">
                                </div>
                                <hr> 
                                <div class="inputValue">
                                    <input type="number" id="quantidades" name="qtPalletsSantosLots" [(ngModel)]="volRecebimento.qtPalletsSantosLots">
                                </div>
                                <hr> 
                                <div class="inputValue">
                                    <input type="number" id="quantidades" name="qtPalletsCrageaSuzan" [(ngModel)]="volRecebimento.qtPalletsCrageaSuzan">
                                </div>
                                <hr> 
                                <div class="inputValue">
                                    <input type="number" id="quantidades" name="qtPalletsSantosSuzan" [(ngModel)]="volRecebimento.qtPalletsSantosSuzan">
                                </div>
                                <hr> 
                                <div class="inputValue">
                                    <input type="number" id="quantidades" name="qtPalletsCrageaGlovis" [(ngModel)]="volRecebimento.qtPalletsCrageaGlovis">
                                </div>
                                <hr> 
                                <div class="inputValue">
                                    <input type="number" id="quantidades" name="qtPalletsSantosGlovis" [(ngModel)]="volRecebimento.qtPalletsSantosGlovis">
                                </div>
                                <hr> 
                                <div class="inputValue">
                                    <input type="number" id="quantidades" name="qtPalletsMRjsl" [(ngModel)]="volRecebimento.qtPalletsMRjsl">
                                </div>
                                <hr> 
                                <div class="inputValue">
                                    <input type="number" id="quantidades" name="qtPalletsDiretos" [(ngModel)]="volRecebimento.qtPalletsDiretos">
                                </div>
                                <hr> 
                                <div class="inputValue">
                                    <input type="number" id="quantidades" name="qtPalletsMRtcm" [(ngModel)]="volRecebimento.qtPalletsMRtcm">
                                </div>
                                <hr> 
                                <div class="inputValue">
                                    <input type="number" id="quantidades" name="qtPalletsARGjsl" [(ngModel)]="volRecebimento.qtPalletsARGjsl">
                                </div>
                            </td>
                            <td class="centralizado">
                                <div class="inputValue marginCima">
                                    <input  [disabled]="true" type="number" id="quantidades" name="qtMediaFE" [ngModel]="volRecebimento.qtMediaFE">
                                </div>
                                <hr> 
                                <div class="inputValue">
                                    <input  [disabled]="true" type="number" id="quantidades" name="qtMediaAereo" [(ngModel)]="volRecebimento.qtMediaAereo">
                                </div>
                                <hr> 
                                <div class="inputValue">
                                    <input  [disabled]="true" type="number" id="quantidades" name="qtMediaCrageaLots" [(ngModel)]="volRecebimento.qtMediaCrageaLots">
                                </div>
                                <hr> 
                                <div class="inputValue">
                                    <input  [disabled]="true" type="number" id="quantidades" name="qtMediaSantosLots" [(ngModel)]="volRecebimento.qtMediaSantosLots">
                                </div>
                                <hr> 
                                <div class="inputValue">
                                    <input  [disabled]="true" type="number" id="quantidades" name="qtMediaCrageaSuzan" [(ngModel)]="volRecebimento.qtMediaCrageaSuzan">
                                </div>
                                <hr> 
                                <div class="inputValue">
                                    <input  [disabled]="true" type="number" id="quantidades" name="qtMediaSantosSuzan" [(ngModel)]="volRecebimento.qtMediaSantosSuzan">
                                </div>
                                <hr> 
                                <div class="inputValue">
                                    <input  [disabled]="true" type="number" id="quantidades" name="qtMediaCrageaGlovis" [(ngModel)]="volRecebimento.qtMediaCrageaGlovis">
                                </div>
                                <hr> 
                                <div class="inputValue">
                                    <input  [disabled]="true" type="number" id="quantidades" name="qtMediaSantosGlovis" [(ngModel)]="volRecebimento.qtMediaSantosGlovis">
                                </div>
                                <hr> 
                                <div class="inputValue">
                                    <input  [disabled]="true" type="number" id="quantidades" name="qtMediaMRjsl" [(ngModel)]="volRecebimento.qtMediaMRjsl">
                                </div>
                                <hr> 
                                <div class="inputValue">
                                    <input  [disabled]="true" type="number" id="quantidades" name="qtMediaDiretos" [(ngModel)]="volRecebimento.qtMediaDiretos">
                                </div>
                                <hr> 
                                <div class="inputValue">
                                    <input  [disabled]="true" type="number" id="quantidades" name="qtMediaMRtcm" [(ngModel)]="volRecebimento.qtMediaMRtcm">
                                </div>
                                <hr> 
                                <div class="inputValue">
                                    <input  [disabled]="true" type="number" id="quantidades" name="qtMediaARGjsl" [(ngModel)]="volRecebimento.qtMediaARGjsl">
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div *ngIf="dataLoaded" class="table-container scrollable-container">
                <table class="geralTable">
                    <thead class="sticky-header">
                        <tr>
                            <th class="titulos-inserir" colspan="3">
                                <span class="semFundo">TOTAL</span>
                            </th>
                            <th class="titulos-inserir">
                                <div class="inputValue marginCima">
                                    <span>VEÍCULOS</span>
                                    <input [disabled]="true" type="text" name="veicTotal" [(ngModel)]="volRecebimento.veicTotal">
                                </div>
                            </th>
                            <th class="titulos-inserir">
                                <div class="inputValue marginCima">
                                    <span>PALLETS</span>
                                    <input [disabled]="true" type="text" name="palletsTotal" [(ngModel)]="volRecebimento.palletsTotal">
                                </div>
                            </th>
                            <th class="titulos-inserir">
                                <div class="inputValue marginCima">
                                    <span>MÉDIA</span>
                                    <input [disabled]="true" type="text" name="mediaTotal" [(ngModel)]="volRecebimento.mediaTotal">
                                </div>
                            </th>
                        </tr>
                    </thead>
                </table>
            </div>
            <div class="modal-div botoes">
                <button class="modal-button" type="button" (click)="salvar(volRecebimento)">Save</button>
                <button class="modal-button" type="button" (click)="cancel()">Cancel</button>
            </div>
        </form>
    </div>
</clr-modal> -->


<div *ngIf="isLoading" class="spinner-overlay">
    <div class="spinner">
        <mat-spinner></mat-spinner>
    </div>
</div>